import throttle from 'lodash.throttle';
import { addClass, removeClass } from '../tools/DOM';
import * as Event from '../tools/Event';


export const init = () => {
	const elements = [...document.querySelectorAll('[data-waypoints]')];

	const init = (element) => {
		const links = [...element.querySelectorAll('[href^="#"]')];
		const items = links
			.map((link) => {
				const id = link.getAttribute('href');
				const section = document.querySelector(id);
				const item = link.closest('li');

				if (section) {
					return {
						item,
						section,
					};
				}

				return false;
			})
			.filter((section) => section);

		const onScroll = () => {
			const windowHeight = window.innerHeight;
			const current = items
				.map((item, index) => {
					const nextItem = items[index + 1];

					if (!nextItem) return item;

					const rect = nextItem.section.getBoundingClientRect();

					if (rect.top <= (windowHeight / 2)) {
						return false;
					}

					return item;
				})
				.filter((item) => item);

			if (current.length) {
				items.forEach((item) => {
					removeClass(item.item, 'is-active');
				});
				addClass(current[0].item, 'is-active');
			}
		};

		Event.on(window, 'scroll', throttle(onScroll, 100));
	};


	elements.forEach(init);
};



// WEBPACK FOOTER //
// ./src/js/components/waypoints.js